import Vue from 'vue'
import Vuex from 'vuex'
import { loadNodes } from '@/api/nodes'

const { VUE_APP_BUILD_ENV } = process.env
Vue.use(Vuex)

const $state = {
  isIEF: VUE_APP_BUILD_ENV === 'IEF',
  isFabric: VUE_APP_BUILD_ENV === 'Fabric',
  nodeIdForFabric: '',
  lang: localStorage.getItem('language') || 'en',
  theme: localStorage.getItem('theme') || 'dark',
  user: JSON.parse(localStorage.user || sessionStorage.user || '{}') || {},
  nodes: [],
  currentNode: JSON.parse(localStorage.getItem('currentNode')) || {},
  subAppInstances: {
    flow: null,
  },
  isLoadingSubApp: false,
}

const getNodes = async () => {
  const nodes = JSON.parse(localStorage.getItem('nodes'))
  const getNodesByAPI = async () => {
    const res = await loadNodes()
    const $nodes = res.data.map((item) => ({
      label: item.name,
      value: item.id,
    }))
    return $nodes
  }
  if (!nodes) {
    getNodesByAPI().then((data) => {
      $state.nodes = data
      localStorage.setItem('nodes', JSON.stringify(data))
    })
  } else {
    $state.nodes = nodes
  }
}
getNodes()

export default new Vuex.Store({
  state: $state,
  mutations: {
    SET_LANGUAGE(state, lang) {
      state.lang = lang
    },
    SET_THEME(state, lang) {
      state.lang = lang
    },
    UPDATE_USER_INFO(state, userInfo) {
      state.user = userInfo
    },
    SET_NODES(state, nodes) {
      state.nodes = nodes
    },
    SET_CURRENTNODE(state, currentNode) {
      state.currentNode = currentNode
    },
    SET_NODE_ID_FOR_FABRIC(state, nodeId) {
      state.nodeIdForFabric = nodeId
    },
    // sub app
    SET_SUB_APP_INSTANCE(state, payload) {
      const { key, instance } = payload
      state.subAppInstances[key] = instance
    },
    SET_SUB_APP_LOADING(state, payload) {
      state.isLoadingSubApp = payload
    },
  },
  actions: {
    SET_LANGUAGE({ commit }, lang = 'en') {
      localStorage.setItem('language', lang)
      commit('SET_LANGUAGE', lang)
      setTimeout(() => {
        window.location.reload()
      }, 400)
    },
    SET_THEME({ commit }, theme = 'dark') {
      localStorage.setItem('theme', theme)
      commit('SET_THEME', theme)
      setTimeout(() => {
        window.location.reload()
      }, 400)
    },
    UPDATE_USER_INFO({ commit }, userInfo = {}) {
      const { logout = false, remember } = userInfo
      if (logout) {
        localStorage.removeItem('user')
        sessionStorage.removeItem('user')
      } else if (remember) {
        localStorage.setItem('user', JSON.stringify(userInfo))
      } else {
        sessionStorage.setItem('user', JSON.stringify(userInfo))
      }
      commit('UPDATE_USER_INFO', logout ? {} : userInfo)
    },
    SET_NODES({ commit }, nodes) {
      localStorage.setItem('nodes', JSON.stringify(nodes))
      commit('SET_NODES', nodes)
    },
    SET_CURRENTNODE({ commit }, currentNode) {
      const { id, name, refresh } = currentNode
      localStorage.setItem('currentNode', JSON.stringify({ id, name }))
      commit('SET_CURRENTNODE', { id, name })
      if (refresh) {
        setTimeout(() => {
          window.location.reload()
        }, 400)
      }
    },
  },
})
